
import React, { useState } from 'react';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import { Phone, Mail } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white shadow-sm">
      <div className="container mx-auto px-4 md:px-6">
        {/* Contact bar */}
        <div className="hidden md:flex items-center space-x-6 py-2 border-b text-sm">
          <a href="tel:+16147728925" className="flex items-center text-navy hover:text-gold transition-colors">
            <Phone className="h-4 w-4 mr-2" />
            <span>(614) 772-8925</span>
          </a>
          <a href="mailto:info@goldstandardcleaninggroup.com" className="flex items-center text-navy hover:text-gold transition-colors">
            <Mail className="h-4 w-4 mr-2" />
            <span>info@goldstandardcleaninggroup.com</span>
          </a>
        </div>

        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center">
            <img 
              src="/lovable-uploads/1512413c-857e-420d-a570-2809cafefb1a.png" 
              alt="Gold Standard Cleaning Group Logo" 
              className="h-10 w-10 mr-2" 
            />
            <div>
              <span className="text-navy font-serif font-bold text-xl">GOLD STANDARD</span>
              <span className="block text-xs uppercase tracking-widest text-gold">Cleaning Group</span>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:block">
            <ul className="flex space-x-8">
              {["Home", "Services", "About", "Contact"].map((item) => (
                <li key={item}>
                  <a 
                    href={`#${item.toLowerCase()}`}
                    className="text-gray-700 hover:text-navy transition-colors duration-300 text-sm uppercase tracking-wide font-medium"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          {/* CTA Button - Updated to link to phone number */}
          <Button 
            className="hidden md:inline-flex bg-navy hover:bg-navy/90 text-white"
            asChild
          >
            <a href="tel:+16147728925" className="flex items-center">
              <Phone className="mr-2 h-4 w-4" />
              Speak with Our Concierge
            </a>
          </Button>

          {/* Mobile menu button */}
          <button 
            className="md:hidden text-gray-700 focus:outline-none"
            onClick={toggleMenu}
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              {isMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Navigation */}
        <div className={cn("md:hidden", isMenuOpen ? "block" : "hidden")}>
          <div className="pt-2 pb-4 border-t border-gray-200">
            <ul>
              {["Home", "Services", "About", "Contact"].map((item) => (
                <li key={item} className="block py-2">
                  <a 
                    href={`#${item.toLowerCase()}`}
                    className="text-gray-700 hover:text-navy transition-colors duration-300 text-base px-4 block"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {item}
                  </a>
                </li>
              ))}
              
              <li className="mt-4 space-y-3 p-4 bg-gradient-to-r from-navy/5 to-gold/5 rounded-lg mx-4">
                <a 
                  href="tel:+16147728925"
                  className="flex items-center text-navy hover:text-gold transition-colors font-semibold"
                >
                  <Phone className="h-5 w-5 mr-2" />
                  <span>(614) 772-8925</span>
                </a>
                <a 
                  href="mailto:info@goldstandardcleaninggroup.com"
                  className="flex items-center text-navy hover:text-gold transition-colors font-semibold"
                >
                  <Mail className="h-5 w-5 mr-2" />
                  <span>info@goldstandardcleaninggroup.com</span>
                </a>
              </li>

              <li className="mt-4 px-4">
                <Button className="w-full bg-navy hover:bg-navy/90 text-white" asChild>
                  <a href="tel:+16147728925" className="flex items-center justify-center">
                    <Phone className="mr-2 h-4 w-4" />
                    Speak with Our Concierge
                  </a>
                </Button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
